/**
 * Convert Redux company ID string (e.g., 'company_1') to numeric ID for backend API calls.
 * Follows the same parseInt(id.replace('prefix_', '')) pattern used for conversation IDs in omapApi.ts.
 */
export function getNumericCompanyId(companyIdStr: string | null): number {
  if (!companyIdStr) return 1
  const num = parseInt(companyIdStr.replace('company_', ''))
  return isNaN(num) ? 1 : num
}
